<app-form-base *ngIf="paxForm" [formGroup]="paxForm">
  <ng-container content>
    <app-edit-form-default *ngIf="activeDeleteFormData"  (clickDelete)="deleteFormData()"></app-edit-form-default>
    <div class="paxForm__row">
      <p class="paxForm__row-title">{{'BOOKING_MODULE.PERSONAL_INFO' | transloco}}</p>
      <div class="paxForm__row-inputs" #firstName>
        <app-form-text-input
          [ngStyle]="{ 'width': '50%' }"
          [form]="paxForm"
          [formControlSelector]="firstNameKey"
          [id]="firstNameKey"
          [maxLength]="50"
          [isSubmitted]="isSubmitted"
          [placeholder]="'BOOKING_MODULE.FIRST_NAME' | transloco"
          [required]="isRequired"
          [formInputType]="onlyLettersInput"
          (keyUp)="changeUpperCaseGuestName($event, firstNameKey)"
          (click)="scroll(firstNameRef)">
        </app-form-text-input>
        <section #secondName [ngStyle]="{ 'width': '50%' }">
          <app-form-text-input
            [form]="paxForm"
            [formControlSelector]="secondNameKey"
            [id]="secondNameKey"
            [maxLength]="50"
            [formInputType]="onlyLettersInput"
            [isSubmitted]="isSubmitted"
            [required]="isRequired"
            [placeholder]="'BOOKING_MODULE.SECOND_NAME' | transloco"
            (keyUp)="changeUpperCaseGuestName($event, secondNameKey)"
            (click)="scroll(secondNameRef)">
          </app-form-text-input>
        </section>
      </div>
    </div>
    <div class="paxForm__row">
      <div class="paxForm__row-inputs" #lastName>
        <app-form-text-input
          [ngStyle]="{ 'width': '100%' }"
          [form]="paxForm"
          [formControlSelector]="lastNameKey"
          [id]="lastNameKey"
          [maxLength]="50"
          [formInputType]="onlyLettersInput"
          [isSubmitted]="isSubmitted"
          [required]="isRequired"
          [placeholder]="'BOOKING_MODULE.LAST_NAMES' | transloco"
          (keyUp)="changeUpperCaseGuestName($event, lastNameKey)"
          (click)="scroll(lastNameRef)">
        </app-form-text-input>
      </div>
    </div>
    <ng-container *ngIf="isRequired">
      <div class="paxForm__row" *ngIf="!disabledDocumentInputs">
        <div class="paxForm__row-inputs inline" #documentNumber>
          <app-form-document-input
            #documentSelectorRef
            [form]="paxForm"
            [documents]="documents"
            [isSubmitted]="isSubmitted"
            [travelerBookingProvider]="travelerBookingProvider"
            [type]="type"
            [isInternationalTrip]="isAnInternationalTrip"
            [defaultDocument]="defaultDocument"
            [validators]="travelerFormDocumentValidators"
            [documentType]="documentType"
            [isMobile]="isMobile"
            (documentSelected)="onDocumentTypeSelected($event)">
          </app-form-document-input>
        </div>
      </div>
      <div class="paxForm__row" #nationality>
        <app-country-selector
          [form]="paxForm"
          [defaultCode]="defaultCode"
          [countries]="countries"
          [isSubmitted]="isSubmitted"
          [disabledCountryOptions]="disabledCountryOptions"
          [isMobile]="isMobile">
        </app-country-selector>
      </div>
      <div class="paxForm__row" #dob>
        <app-input-date #dobInputRef
          [form]="paxForm"
          [defaultDate]="defaultDate"
          [invalidDate]="invalidDate"
          [isSubmitted]="isSubmitted"
          [yearsRangeForChildren]="yearsRangeForChildren"
          [isSubmittedSuccess]="isSubmittedSuccess"
          [type]="type"
          [min]="minAges"
          [max]="maxAges"
          [usedAges]="!!travelerAge"
          [age]="travelerAge"
          [travelerInfoType]="travelerInfoType"
          [isMobile]="isMobile">
        </app-input-date>
      </div>
      <div class="paxForm__row" #genderRadio>
        <app-gender-selector
          [idSelector]="genderStringSelector"
          [isSubmitted]="isSubmitted"
          [user]="user"
          [form]="paxForm">
        </app-gender-selector>
      </div>
      <div class="paxForm__row" *ngIf="!hasPaxTravelerInfo">
        <div class="paxForm__row-inputs">
          <fieldset class="input">
            <div class="checkbox">
              <input id="add-list"
                [checked]="isCreateTraveler"
                autocomplete="off" maxlength="50" type="checkbox" (click)="setSaveFormData()">
              <label for="add-list" class="last-name">{{'BOOKING_MODULE.PAX.SAVE_IN_LIST' | transloco}}</label>
            </div>
          </fieldset>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container button>
    <ng-container *ngIf="isMobile; else desktopPaxBtn">
      <app-fixed-surface>
        <ng-container *ngTemplateOutlet="buttonCont"></ng-container>
      </app-fixed-surface>
    </ng-container>

    <ng-template #desktopPaxBtn>
      <div class="paxForm__button__desktop">
        <ng-container *ngTemplateOutlet="buttonCont"></ng-container>
      </div>
    </ng-template>

    <ng-template #buttonCont>
      <app-ds-button
        [isLoading]="isLoadingPaxForm"
        [labels]="{ ButtonLabel: 'BOOKING_MODULE.PAX.SAVE' | transloco }"
        (clickEvent)="save()">
      </app-ds-button>
    </ng-template>
  </ng-container>

</app-form-base>
